<template>
  <div id="account" class="account">
    <h2 class="page-heading">Account</h2>
    <div>
      <form @submit.prevent="updatePassword" @keydown.enter.prevent>
        <fieldset>
          <legend>Change password</legend>
          <div class="form-row">
            <label for="username">Email / Username</label>
            <input id="username" type="email" v-model="getEmail" autocomplete="username" readonly />
          </div>
          <div class="form-row">
            <label for="newPassword1">New password</label>
            <div class="form-row__inner-row">
              <button type="button" @click="generatePassword" class="generate-password-btn">Generate</button>
              <input id="newPassword1" :type="showingPassword ? 'text' : 'password'" v-model="newPassword1" minlength="6" autocomplete="new-password" required />
            </div>
          </div>
          <div class="form-row">
            <label for="newPassword2">Confirm new password</label>
            <div class="form-row__inner-row">
              <button type="button" @click="togglePasswordVisibility" class="toggle-visibility-btn">
                <span class="sr-only">{{ togglePasswordVisibilityButtonText }}</span
                ><span v-if="showingPassword" class="material-icons">
                  visibility
                </span>
                <span v-else class="material-icons">
                  visibility_off
                </span>
              </button>
              <input id="newPassword2" :type="showingPassword ? 'text' : 'password'" v-model="newPassword2" minlength="6" autocomplete="new-password" required />
            </div>
          </div>
        </fieldset>
        <button type="submit" disabled>Update password (not working correctly)</button>
        <button type="button" @click="onCancel" class="button button--as-link cancel-btn">Cancel</button>
      </form>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import firebase from 'firebase/app';

import logUserActivity from './../helpers/logUserActivity';
import {CHANGED_PASSWORD} from './../constants/activityLogs';
import getFormattedTimestamp from './../helpers/getFormattedTimestamp';
import {GENERATE_PASSWORD_LENGTH, GENERATE_PASSWORD_CHARS_POOL, NOTIFICATION_SETTINGS} from './../constants/globalConstants';
import generatePassword from './../helpers/generatePassword';
import copyToClipboard from './../helpers/copyToClipboard';

const userVuexModule = createNamespacedHelpers('userVuexModule');

export default {
  name: 'account',
  title: 'Account',
  components: {},
  data: function() {
    return {
      firebaseErrorMessage: '',
      newPassword1: '',
      newPassword2: '',
      passwordResetEmailSent: false,
      showingPassword: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    updatePassword: function() {
      firebase
        .auth()
        .currentUser.updatePassword(this.getEmail)
        .then(resp => {
          this.passwordResetEmailSent = true;
          this.newPassword1 = '';
          this.newPassword2 = '';
          // console.log('Password has been updated');
        })
        .catch(err => {
          this.firebaseErrorMessage = err.message;
          this.$snotify.error('Error updating password', '', NOTIFICATION_SETTINGS);
        });
    },
    generatePassword: function() {
      const generatedPassword = generatePassword(GENERATE_PASSWORD_LENGTH, GENERATE_PASSWORD_CHARS_POOL);
      this.newPassword1 = generatedPassword;
      this.newPassword2 = generatedPassword;
      copyToClipboard(generatedPassword);
      this.$snotify.info('New password copied to clipboard', '', NOTIFICATION_SETTINGS);
    },
    togglePasswordVisibility: function() {
      this.showingPassword = !this.showingPassword;
    },
    onCancel: function() {
      this.$router.go(-1);
    },
  },
  computed: {
    ...userVuexModule.mapGetters(['getEmail']),
    togglePasswordVisibilityButtonText: function() {
      return this.showingPassword ? 'Hide password' : 'Show password';
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.form-row__inner-row {
  display: flex;
  flex-direction: column;
  width: 100%;

  @include breakpoint($mq-sm-md) {
    flex-direction: row-reverse;
  }
}

.generate-password-btn,
.toggle-visibility-btn {
  margin-bottom: 1rem;
  height: 4rem;
  width: 100%;

  @include breakpoint($mq-sm-md) {
    flex-basis: 0;
    margin-bottom: 0;
    margin-left: 1rem;
    min-width: 10rem;
    padding: 0 1.5rem;
    width: 10rem;
  }
}

.cancel-btn {
  margin-top: 2rem;
}
</style>
